import { Button, Dialog, DialogContent, DialogActions } from "@material-ui/core";
import { DatePicker, MaterialUiPickersDate } from "@material-ui/pickers";
import React, { useCallback, useState } from "react";

import { Box } from "../../../../../dtos/box";

import { useChangeLeaseEndDate } from "./useChangeLeaseEndDate";

interface Props {
    open: boolean;
    onClose: () => void;
    box: Box;
    onLeaseEndDateSaved: () => void;
}

export function LeaseEndDateEditDialog({
    open,
    onClose,
    box,
    onLeaseEndDateSaved,
}: Props) {
    const [endDate, setEndDate] = useState<Date | null>(
        box.leaseEndDate ? new Date(box.leaseEndDate) : new Date()
    );
    const { changeLeaseEndDate, loading } = useChangeLeaseEndDate(box.id);

    const handleChange = useCallback((date: MaterialUiPickersDate) => {
        setEndDate(date && date.toDate());
    }, []);

    const handleSave = useCallback(() => {
        changeLeaseEndDate(endDate, () => {
            onLeaseEndDateSaved();
            onClose();
        });
    }, [endDate, onLeaseEndDateSaved, changeLeaseEndDate, onClose]);

    return (
        <Dialog open={open} onClose={onClose}>
            <DialogContent>
                <div>
                    <DatePicker
                        label="End Date"
                        value={endDate}
                        onChange={handleChange}
                        clearable={true}
                    />
                </div>
            </DialogContent>
            <DialogActions>
                <Button
                    color="primary"
                    variant="contained"
                    onClick={handleSave}
                    disabled={loading}
                >
                    {loading ? "Saving..." : "Save End Date"}
                </Button>
                <Button
                    color="secondary"
                    variant="contained"
                    onClick={onClose}
                >
                    Cancel
                </Button>
            </DialogActions>
        </Dialog>
    );
}
